// generated from 4 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceWaidFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_waid_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 3 (75.00%), defined 1 (25.00%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
